var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignupBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 704,
    height: 702,
    viewBox: "0 0 704 702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16026",
    "data-name": "Rectangle 16026",
    width: 704,
    height: 702,
    transform: "translate(-19398 4546)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16025",
    "data-name": "Rectangle 16025",
    width: 704,
    height: 906.356,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_6",
    x: -67.498,
    y: -268.76,
    width: 809.457,
    height: 1041.26,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "signup_1",
    "data-name": "signup 1",
    transform: "translate(19398 -4546)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_781",
    "data-name": "Mask Group 781",
    transform: "translate(-19397.734 4341.644)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38251",
    "data-name": "Group 38251",
    transform: "translate(-0.265 0.096)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38250",
    "data-name": "Group 38250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M403.979,906.26H52.207V0H373.18a110.976,110.976,0,0,1,27.479,3.449,108.783,108.783,0,0,1,25.179,9.9,104.967,104.967,0,0,1,21.652,15.68,100.512,100.512,0,0,1,16.9,20.79l201.77,330.625a98.994,98.994,0,0,1,6.1,11.633,88.216,88.216,0,0,1,4.23,11.8,84.59,84.59,0,0,1,2.424,12,87.655,87.655,0,0,1,.682,12.235,105.927,105.927,0,0,1-3.612,25.312,160.09,160.09,0,0,1-9.823,26.662L495.186,856.441a72.935,72.935,0,0,1-15.41,22.614,83.219,83.219,0,0,1-21.817,15.478C442.552,902.2,423.886,906.26,403.979,906.26Zm-379.411,0h0Z",
    transform: "translate(24.965 0)",
    fill: "#0f62eb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 204.26)",
    filter: "url(#Subtraction_6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_6-2",
    "data-name": "Subtraction 6",
    d: "M398.783,906.26H0V0H367.984a110.976,110.976,0,0,1,27.479,3.449,108.787,108.787,0,0,1,25.179,9.9,104.966,104.966,0,0,1,21.652,15.68,100.514,100.514,0,0,1,16.9,20.79l201.77,330.625a93.369,93.369,0,0,1,10.35,23.522,86.785,86.785,0,0,1,3.139,24.384,104.8,104.8,0,0,1-3.605,25.342,151.534,151.534,0,0,1-9.884,26.395L489.99,856.441a77.673,77.673,0,0,1-15.706,21.722A90.517,90.517,0,0,1,452.5,893.74a110.093,110.093,0,0,1-25.841,9.382A124.29,124.29,0,0,1,398.783,906.26Z",
    transform: "translate(0 -204.26)",
    fill: "#0f62eb"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupBlue);
export default __webpack_public_path__ + "static/media/signup_blue.eba8eb8814807a5a9f8f2eb30ec01c01.svg";
export { ForwardRef as ReactComponent };